var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMegaphoneDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 10.5472V6C18.75 5.58579 18.4142 5.25 18 5.25H17.25C15.7661 6.73398 12.977 7.56546 11.25 7.95961V16.0404C12.977 16.4345 15.7661 17.2661 17.25 18.75H18C18.4142 18.75 18.75 18.4142 18.75 18V13.4528C19.3969 13.2863 19.875 12.6989 19.875 12C19.875 11.3011 19.3969 10.7137 18.75 10.5472ZM6.75 8.25C5.92157 8.25 5.25 8.92157 5.25 9.75V14.25C5.25 15.0785 5.92157 15.75 6.75 15.75H7.5L8.25 19.5H9.75V8.25H6.75Z",
    fill: "#CDD0D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMegaphoneDisabled);
export default __webpack_public_path__ + "static/media/megaphoneDisabled.28361e59df1116580c0db21a4ba9f45c.svg";
export { ForwardRef as ReactComponent };